import React from "react";
import LegalPage, { H2, P, UL } from "./LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy">

      <H2>1. Information We Collect</H2>
      <P>We may collect the following information:</P>
      <UL>
        <li>Name, phone number, and email</li>
        <li>Delivery address</li>
        <li>Payment information (processed via secure third-party gateways)</li>
        <li>Location data</li>
        <li>Family size preferences (for Flavors)</li>
        <li>Device and usage information</li>
      </UL>

      <H2>2. How We Use Your Information</H2>
      <P>We use collected data to:</P>
      <UL>
        <li>Process and deliver orders</li>
        <li>Improve user experience</li>
        <li>Personalize meal planning</li>
        <li>Send updates and promotional communication</li>
      </UL>

      <H2>3. Data Sharing</H2>
      <P>We may share data with:</P>
      <UL>
        <li>Delivery partners</li>
        <li>Payment processors</li>
        <li>Technology service providers</li>
      </UL>
      <P>We do not sell personal data.</P>

      <H2>4. Data Security</H2>
      <P>
        Grox24 implements reasonable security measures to protect user data.
        However, no digital transmission is completely secure.
      </P>

      <H2>5. User Rights</H2>
      <P>Under Indian law, users may:</P>
      <UL>
        <li>Request access to personal data</li>
        <li>Request correction or deletion</li>
        <li>Withdraw consent where applicable</li>
      </UL>
      <P>Requests can be sent to: support@grox24.com</P>

      <H2>6. Data Retention</H2>
      <P>
        We retain user data only as long as necessary for business or legal
        purposes.
      </P>

    </LegalPage>
  );
}